export const isStringIndexable = (o: unknown): o is {[index: string]: unknown} => (
  typeof o === 'object' && o !== null && Object.keys(o).every(k => typeof k === 'string')
);
